<script lang="ts" setup>
  import type { HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import { DialogTitle, type DialogTitleProps, useForwardProps } from 'reka-ui'
  import { cn } from '@/lib/utils'

  const props = defineProps<DialogTitleProps & { class?: HTMLAttributes['class'] }>()

  const delegatedProps = reactiveOmit(props, 'class')

  const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <DialogTitle :class="cn('text-lg font-semibold leading-none tracking-tight', props.class)" v-bind="forwardedProps">
    <slot />
  </DialogTitle>
</template>
